import React, { Component, Fragment } from 'react';
import {
    View,
    TouchableOpacity,
    CheckBox,
    Platform,
    Dimensions
} from 'react-native';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import { Creators as toastActions } from '../../store/ducks/toast';

import Text from '../../react-component/textComponent';
import ProductImage from '../../react-component/productImage';

import { formatToReal, formatToMilhar } from '../../config/Format';

import { urlCdn } from '../../services/Api';

import styles, { StyledInput } from './styles';
import Colors from '../../config/Colors';

import { separarProdutoPedido } from './api';
import { ShoppingBag, Store } from '@mui/icons-material';

const { width } = Dimensions.get('window'),
    isDesktop = Platform.OS === 'web' && width > 720;

const unidadeMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 3,
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.'
});

class ItemPedido extends Component {
    state = {
        checked: false,
        fgSeparado: false,
        qtProduto: 0,
        qtProdutoOriginal: 0,
        vlTotal: 0,
        fgAdicionado: 0
    };

    componentDidMount() {
        const { item } = this.props,
            { fgSeparado, fgAdicionado } = item,
            checked = fgSeparado === 1,
            vlTotal = formatToReal(
                fgSeparado ? item.vlTotalSeparado : item.vlTotal
            ),
            qtProdutoOriginal = item.qtProduto,
            qtProduto = formatToMilhar(
                fgSeparado ? item.qtSeparado : item.qtProduto
            );

        this.setState({
            ...this.state,
            qtProduto,
            qtProdutoOriginal,
            checked,
            fgSeparado,
            vlTotal,
            fgAdicionado
        });
    }

    handleQuantidadeChange = (e) => {
        const { target } = e,
            { value } = target;

        let qtProduto = value;

        const { item, formaPagamento } = this.props,
            { fgPesavel, vlUnitario } = item;

        let newValue = Number(value.replace(',', '.')),
            vlTotalSeparado = newValue * vlUnitario;

        if (isNaN(newValue)) {
            qtProduto = formatToMilhar(this.state.qtProdutoOriginal);

            vlTotalSeparado = this.state.qtProdutoOriginal * vlUnitario;
        }

        if (!fgPesavel) {
            if (this.isDecimal(newValue)) {
                newValue = parseInt(newValue, 10);

                qtProduto = formatToMilhar(newValue);

                vlTotalSeparado = newValue * vlUnitario;
            }

            if (newValue > this.state.qtProdutoOriginal) {
                qtProduto = formatToMilhar(this.state.qtProdutoOriginal);

                vlTotalSeparado = this.state.qtProdutoOriginal * vlUnitario;
            }
        }

        if (formaPagamento.fgOnline && fgPesavel) {
            if (newValue > this.state.qtProdutoOriginal) {
                qtProduto = formatToMilhar(this.state.qtProdutoOriginal);

                vlTotalSeparado = this.state.qtProdutoOriginal * vlUnitario;
            }
        }

        item.vlTotal = vlTotalSeparado;
        item.vlTotalSeparado = vlTotalSeparado;

        this.setState({
            ...this.state,
            qtProduto,
            vlTotal: vlTotalSeparado
        });
    };

    isDecimal = (num) => {
        if (isNaN(num)) return false;

        return parseInt(num, 10) !== parseFloat(num);
    };

    handleQuantidadeBlur = (e) => {
        const { target } = e;

        let { value } = target;

        if (value && value.length >= 11) return;

        value = Number(value.replace(',', '.'));

        const { item, formaPagamento } = this.props,
            { fgPesavel, vlUnitario } = item;

        let { qtProduto } = item;

        if (formaPagamento.fgOnline) {
            if (value <= qtProduto) {
                qtProduto = value;
            }
        } else {
            if (!fgPesavel) {
                if (value <= qtProduto) {
                    qtProduto = value;
                }
            } else {
                qtProduto = value;
            }
        }

        const vlTotal = qtProduto * vlUnitario;

        item.vlTotal = vlTotal;
        item.vlTotalSeparado = vlTotal;

        qtProduto = formatToMilhar(qtProduto);

        this.setState({
            ...this.state,
            qtProduto,
            vlTotal
        });
    };

    handleFocus = (e) => {
        e.target.select();
    };

    render() {
        const {
                user,
                item,
                showItemActions = true,
                idStatusPedido
            } = this.props,
            { configLoja = {} } = user,
            { fgKds = false } = configLoja,
            { checked, qtProduto, fgAdicionado } = this.state,
            {
                dsProduto,
                fgPesavel,
                dsObservacao,
                fgSeparado,
                fgProdutoViagem = false
            } = item,
            vlUnitario = Number(item.vlUnitario).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }),
            nrEan = item.nrEan,
            listObservacao = dsObservacao ? dsObservacao.split('\n') : [],
            vlTotal = Number(
                fgSeparado ? item.vlTotalSeparado : item.vlTotal
            ).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }),
            tpUnidade = fgPesavel ? ' KG' : ' UN',
            itemStyle = [
                styles.listItem,
                checked ? styles.styleItemChecked : null,
                fgAdicionado && fgAdicionado === 1
                    ? styles.styleItemCheckedDark
                    : null
            ];

        let listAdd = [],
            listRemov = [],
            listAddNormally = [];

        listObservacao.forEach((item) => {
            if (item[1] === '+') {
                const newItem = item.replace('(+)', '+ ');
                listAdd.push(newItem);
            } else if (item[1] === '-') {
                const newItem = item.replace('(-)', '- ');
                listRemov.push(newItem);
            } else if (/SEM ACOMPANHAMENTO/.test(item)) {
                listRemov.push(item);
            } else {
                listAddNormally.push(item);
            }
        });

        const isZero =
            Boolean(
                Number(qtProduto.toString().replace(',', '').replace('.', ''))
            ) === false;

        return (
            <View style={styles.listItemContainer}>
                {fgKds ? (
                    <TouchableOpacity
                        style={itemStyle}
                        onPress={() =>
                            showItemActions && this.toggleSeparado(item)
                        }
                    >
                        {showItemActions && (
                            <CheckBox
                                value={checked}
                                style={{
                                    width: 20,
                                    height: 20,
                                    marginRight: 16,
                                    alignContent: 'center'
                                }}
                            />
                        )}
                        <ProductImage
                            data={item}
                            urlCdn={urlCdn}
                            style={styles.image}
                            resizeMode={'center'}
                        />
                        <View style={styles.wrapItem}>
                            <View style={styles.headerLine}>
                                <View style={styles.itemName}>
                                    <Text style={styles.text}>{dsProduto}</Text>
                                </View>

                                {Boolean(fgProdutoViagem) && (
                                    <View style={styles.itemForTravel}>
                                        <ShoppingBag
                                            sx={{
                                                fontSize: 20,
                                                color: Colors.secondary
                                            }}
                                        />
                                    </View>
                                )}
                               
                            </View>
                            <View style={styles.itemDetailLine}>
                                <Text
                                    style={[styles.itemInfo, { width: 'auto' }]}
                                >
                                    {nrEan}
                                </Text>
                                <Text
                                    style={[
                                        styles.itemInfo,
                                        styles.itemInfoSep
                                    ]}
                                >
                                    •
                                </Text>

                                <View style={styles.qtProdutoView}>
                                    <Text style={styles.itemInfo}>
                                        {qtProduto}
                                    </Text>

                                    <Text style={styles.itemInfo}>
                                        {tpUnidade}
                                    </Text>
                                </View>

                                {/* <Text
                                    style={[
                                        styles.itemInfo,
                                        styles.itemInfoSep
                                    ]}
                                >
                                    •
                                </Text>
                                <Text style={styles.itemInfo}>
                                    R$ {vlUnitario}
                                </Text> */}
                            </View>

                            <View>
                                <Fragment>
                                    {this.renderObservacaoItems(
                                        listRemov,
                                        styles.itemRemov
                                    )}
                                </Fragment>

                                <Fragment>
                                    {this.renderObservacaoItems(
                                        listAddNormally,
                                        styles.itemAddNormally
                                    )}
                                </Fragment>

                                <Fragment>
                                    {this.renderObservacaoItems(
                                        listAdd,
                                        styles.itemAdd
                                    )}
                                </Fragment>
                            </View>
                        </View>
                    </TouchableOpacity>
                ) : (
                    <View style={itemStyle}>
                        {showItemActions && (
                            <TouchableOpacity
                                onPress={() =>
                                    showItemActions && this.toggleSeparado(item)
                                }
                                disabled={isZero}
                            >
                                <span onClick={() => this.isValidValue(isZero)}>
                                    <CheckBox
                                        value={checked}
                                        style={{
                                            width: 20,
                                            height: 20,
                                            marginRight: 16,
                                            alignContent: 'center'
                                        }}
                                    />
                                </span>
                            </TouchableOpacity>
                        )}
                        <ProductImage
                            data={item}
                            urlCdn={urlCdn}
                            style={styles.image}
                            resizeMode={'center'}
                        />

                        {isDesktop ? (
                            <View style={styles.wrapItem}>
                                <View style={styles.headerLine}>
                                    <View style={styles.itemName}>
                                        <Text style={styles.text}>
                                            {dsProduto}
                                        </Text>
                                    </View>

                                    <View style={styles.itemValue}>
                                        <Text style={styles.totalValueInfo}>
                                            {vlTotal}
                                        </Text>
                                    </View>
                                </View>

                                <View style={styles.itemDetailLine}>
                                    <Text
                                        style={[
                                            styles.itemInfo,
                                            { width: 120 }
                                        ]}
                                    >
                                        {nrEan}
                                    </Text>
                                    <Text
                                        style={[
                                            styles.itemInfo,
                                            styles.itemInfoSep
                                        ]}
                                    >
                                        •
                                    </Text>
                                    <View style={styles.qtProdutoView}>
                                        <MaskedInput
                                            mask={unidadeMask}
                                            id="qtProduto"
                                            name="qtProduto"
                                            value={qtProduto}
                                            maxLength={10}
                                            disabled={
                                                fgSeparado || idStatusPedido > 2
                                            }
                                            onChange={
                                                this.handleQuantidadeChange
                                            }
                                            onBlur={this.handleQuantidadeBlur}
                                            onFocus={this.handleFocus}
                                            render={(ref, props) => (
                                                <StyledInput
                                                    ref={ref}
                                                    {...props}
                                                />
                                            )}
                                            type="tel"
                                        />

                                        <Text style={styles.itemInfo}>
                                            {tpUnidade}
                                        </Text>
                                    </View>
                                    <Text
                                        style={[
                                            styles.itemInfo,
                                            styles.itemInfoSep
                                        ]}
                                    >
                                        •
                                    </Text>
                                    <Text style={styles.itemInfo}>
                                        {vlUnitario}
                                    </Text>
                                    {fgAdicionado && (
                                        <Text style={styles.itemIcon}>
                                            <Store />
                                        </Text>
                                    )}
                                </View>

                                <View>
                                    <Fragment>
                                        {this.renderObservacaoItems(
                                            listRemov,
                                            styles.itemRemov
                                        )}
                                    </Fragment>

                                    <Fragment>
                                        {this.renderObservacaoItems(
                                            listAddNormally,
                                            styles.itemAddNormally
                                        )}
                                    </Fragment>

                                    <Fragment>
                                        {this.renderObservacaoItems(
                                            listAdd,
                                            styles.itemAdd
                                        )}
                                    </Fragment>
                                </View>
                            </View>
                        ) : (
                            <View>
                                <Text style={styles.headerLine}>
                                    {dsProduto}
                                </Text>

                                <Text style={styles.totalValueInfo}>
                                    {vlTotal}
                                </Text>

                                <Text style={[styles.itemInfo, { width: 120 }]}>
                                    {nrEan}
                                </Text>

                                <View style={styles.qtProdutoView}>
                                    <MaskedInput
                                        mask={unidadeMask}
                                        id="qtProduto"
                                        name="qtProduto"
                                        value={qtProduto}
                                        maxLength={10}
                                        disabled={
                                            fgSeparado || idStatusPedido > 2
                                        }
                                        onChange={this.handleQuantidadeChange}
                                        onBlur={this.handleQuantidadeBlur}
                                        onFocus={this.handleFocus}
                                        render={(ref, props) => (
                                            <StyledInput ref={ref} {...props} />
                                        )}
                                        type="tel"
                                    />

                                    <Text style={styles.itemInfo}>
                                        {tpUnidade}
                                    </Text>

                                    <Text
                                        style={[
                                            styles.itemInfo,
                                            styles.itemInfoSep
                                        ]}
                                    >
                                        •
                                    </Text>

                                    <Text style={styles.itemInfo}>
                                        R$ {vlUnitario}
                                    </Text>

                                    {fgAdicionado && (
                                        <Text style={styles.itemIcon}>
                                            <Store />
                                        </Text>
                                    )}
                                </View>

                                <View>
                                    <Fragment>
                                        {this.renderObservacaoItems(
                                            listRemov,
                                            styles.itemRemov
                                        )}
                                    </Fragment>

                                    <Fragment>
                                        {this.renderObservacaoItems(
                                            listAddNormally,
                                            styles.itemAddNormally
                                        )}
                                    </Fragment>

                                    <Fragment>
                                        {this.renderObservacaoItems(
                                            listAdd,
                                            styles.itemAdd
                                        )}
                                    </Fragment>
                                </View>
                            </View>
                        )}
                    </View>
                )}
            </View>
        );
    }

    renderObservacaoItems = (list, itemStyle) => {
        const { user } = this.props,
            { configLoja = {} } = user,
            { fgKds = false } = configLoja,
            maxWidth = isDesktop ? width - 650 : width - 190;

        return (
            <Fragment>
                {list.length > 0 ? (
                    <View style={{ flex: 1 }}>
                        {list.map((observacao, index) =>
                            fgKds ? (
                                <View key={index} style={styles.itemDetailLine}>
                                    <Text style={[styles.itemInfo, itemStyle]}>
                                        {observacao}
                                    </Text>
                                </View>
                            ) : (
                                <View key={index} style={styles.itemDetailLine}>
                                    <Text $bold style={{ marginRight: 10 }}>
                                        Obs.:
                                    </Text>

                                    <View
                                        style={[
                                            styles.itemDescBox,
                                            { maxWidth: maxWidth }
                                        ]}
                                    >
                                        <Text
                                            style={[
                                                styles.itemInfo,
                                                itemStyle,
                                                {
                                                    marginHorizontal: 10
                                                }
                                            ]}
                                        >
                                            {observacao}
                                        </Text>
                                    </View>
                                </View>
                            )
                        )}
                    </View>
                ) : (
                    <Fragment />
                )}
            </Fragment>
        );
    };

    toggleSeparado = async (item) => {
        const { idPedido, updateItemList } = this.props,
            { qtProduto, qtProdutoOriginal } = this.state,
            { idPedidoProduto, vlUnitario } = item,
            fgSeparado = this.state.fgSeparado === 1 ? 0 : 1,
            qtSeparado = qtProduto.replace(/\./g, '').replace(',', '.'),
            body = {
                fgSeparado,
                qtSeparado
            },
            vlTotal = formatToReal(
                fgSeparado ? item.vlTotalSeparado : item.vlTotal
            );

        separarProdutoPedido(idPedido, idPedidoProduto, body)
            .then((response) => {
                item.qtSeparado = qtSeparado;
                item.vlTotalSeparado = item.vlTotal;

                if (fgSeparado) {
                    item.qtProduto = qtProdutoOriginal;

                    let newValue = Number(
                        qtProdutoOriginal.toString().replace(',', '.')
                    );

                    item.vlTotal = newValue * vlUnitario;
                }

                this.setState({
                    ...this.state,
                    checked: !this.state.checked,
                    qtProduto,
                    fgSeparado,
                    vlTotal
                });

                updateItemList({ ...item, fgSeparado });
            })
            .catch((errors) => {
                errors.forEach((error) => {
                    const { message } = error;

                    this.props.addToast({
                        text: message,
                        more: 'OK',
                        theme: 'error'
                    });
                });
            });
    };

    isValidValue = (isZero) => {
        if (isZero) {
            this.props.addToast({
                text: 'Não é possível separar produto com quantidade zerada.',
                more: 'OK',
                theme: 'error'
            });
        }
    };
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...toastActions }, dispatch);

const mapStateToProps = ({ user }) => ({
    user
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemPedido);
